<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent scrollable max-width="600">
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("sysLog") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-alert
                    :value="copiedAlert"
                    style="position: absolute; top: 50px; width: 100%;"
                    type="success"
                    transition="scale-transition"
                >
                    {{ $t("copiedToClipboard") }}
                </v-alert>

                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs4>
                            <b>{{ $t("time") }}:</b>
                        </v-flex>
                        <v-flex xs8>
                            {{ time }}

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        absolute
                                        right
                                        flat
                                        icon
                                        v-on="on"
                                        @click="copyToClipboard"
                                    >
                                        <v-icon>mdi-clipboard-text-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t("copyToClipboard") }}</span>
                            </v-tooltip>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs4>
                            <b>{{ $t("module") }}:</b>
                        </v-flex>
                        <v-flex xs8>
                            {{ moduleName }}
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs4>
                            <b>{{ $t("user") }}:</b>
                        </v-flex>
                        <v-flex xs8>
                            {{ user }}
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs4>
                            <b>IP:</b>
                        </v-flex>
                        <v-flex xs8>
                            {{ ip }}
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs4>
                            <b>{{ $t("type") }}:</b>
                        </v-flex>
                        <v-flex xs8>
                            {{ type }}
                        </v-flex>
                    </v-layout>

                    <v-textarea
                        name="messageText"
                        :label="$t('message')"
                        :value="messageText"
                        readonly
                    ></v-textarea>
                </v-card-text>

                <v-card-text>
                        <div id="parsedCode" class="parsedCode"></div>
                    <v-sheet>
                    </v-sheet>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="dialog = false">ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        name: "SysLogDialog",

        data () {
            return {
                copiedAlert: false,
                dialog: false,
                ip: "",
                moduleName: "",
                time: "",
                type: "",
                user: "",
                messageText: ""
            }
        },

        watch: {
            copiedAlert: function (val) {
                if (val) {
                    setTimeout(() => this.copiedAlert = false, 1500);
                }
            },

            messageText: function (val) {
                if (this.extractJSON(val)[0] !== null) {
                    document.getElementById("parsedCode").innerHTML = this.syntaxHighlight(JSON.stringify(this.extractJSON(val)[0]));
                    document.getElementById("parsedCode").innerHTML = document.getElementById("parsedCode").innerHTML.replaceAll("{", "{<br>&nbsp;&nbsp;&nbsp;&nbsp;");
                    document.getElementById("parsedCode").innerHTML = document.getElementById("parsedCode").innerHTML.replaceAll("}", "<br>}");
                    document.getElementById("parsedCode").innerHTML = document.getElementById("parsedCode").innerHTML.replaceAll(",<span", ",<br>&nbsp;&nbsp;&nbsp;&nbsp;<span");
                    document.getElementById("parsedCode").innerHTML = document.getElementById("parsedCode").innerHTML.replaceAll(":</span>", ":&nbsp;</span>");
                } else {
                    document.getElementById("parsedCode").innerHTML = "";
                }
            }
        },

        methods: {
            /**
             * Копирование сообщения в буфер обмена
             */
            copyToClipboard () {
                const el = document.createElement('textarea');
                el.value = this.$t("time") + ": " + this.time + "\r\n" +
                    this.$t("module") + ": " + this.moduleName + "\r\n" +
                    this.$t("user") + ": " + this.user + "\r\n" +
                    "IP: " + this.ip + "\r\n" +
                    this.$t("type") + ": " + this.type + "\r\n" +
                    this.$t("message") + ":\r\n" +
                    this.messageText;
                el.setAttribute("readonly", "");
                el.style.position = "absolute";
                el.style.left = "-9999px";
                document.body.appendChild(el);
                el.select();
                document.execCommand("copy");
                document.body.removeChild(el);

                this.copiedAlert = true;
            },

            /**
             * Извлечение данных JSON из текста
             *
             * @param {string} str Текстовая строка
             */
            extractJSON (str) {
                let firstOpen;
                let firstClose;
                let candidate;

                firstOpen = str.indexOf("{", firstOpen + 1);

                do {
                    firstClose = str.lastIndexOf("}");

                    //this.$debug.log(`firstOpen: ${firstOpen}, firstClose: ${firstClose}`);

                    if (firstClose <= firstOpen) {
                        return [null, 0, 0];
                    }

                    do {
                        candidate = str.substring(firstOpen, firstClose + 1);
                        candidate = candidate.replaceAll('\\"', '"');

                        //this.$debug.log(`candidate: ${candidate}`);

                        try {
                            let res = JSON.parse(candidate);

                            //this.$debug.log("...found");

                            return [res, firstOpen, firstClose + 1];
                        } catch (e) {
                            //this.$debug.log("...failed");
                            return [null, 0, 0];
                        }

                        // firstClose = str.substr(0, firstClose).lastIndexOf("}");
                    } while(firstClose > firstOpen);

                    // firstOpen = str.indexOf("{", firstOpen + 1);
                } while(firstOpen != -1);
            },

            /**
             * Подсветка синтаксиса
             *
             * @param {string} json Текст в формате JSON
             */
            syntaxHighlight (json) {
                json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

                return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
                    let cls = "number";
                    if (/^"/.test(match)) {
                        if (/:$/.test(match)) {
                            cls = "key";
                        } else {
                            cls = "string";
                        }
                    } else if (/true|false/.test(match)) {
                        cls = "boolean";
                    } else if (/null/.test(match)) {
                        cls = "null";
                    }

                    return `<span class="${cls}">${match}</span>`;
                });
            }
        }
    }
</script>

<style lang="sass">
    .parsedCode
        max-height: 150px
        overflow: auto

    .theme--light
        .parsedCode
            .string
                color: green
            .number
                color: darkorange
            .boolean
                color: blue
            .null
                color: magenta
            .key
                color: red
    .theme--dark
        .parsedCode
            .string
                color: #8ae08a
            .number
                color: darkorange
            .boolean
                color: #7ed5ff
            .null
                color: #fb92fb
            .key
                color: #ff7e7e
</style>